import Base2DElement from "./base-2d-element";
import Network from "../miniviews/network";
import { fire } from "../utils/events";
import RenderManager from "../rendering/render-manager";

const tmp = new THREE.Vector3(), tmp2 = new THREE.Vector3();
class Base2DElementDynamic extends Base2DElement {
    _initDefaultVars() {
        super._initDefaultVars();

        this._vector = new THREE.Vector3();
        this._target = null;
        this._targetPoint = null;
        this._targetUuid = null;
    }

    get vector() { return this._vector; }
    set vector(val) { this._vector = val; }
    get target() { return this._target; }
    set target(val) { this._target = val; }
    get targetPoint() { return this._targetPoint; }
    set targetPoint(val) { this._targetPoint = val; }
    get targetUuid() { return this._targetUuid; }
    set targetUuid(val) { this._targetUuid = val; }

    constructor(options, parentLayer, uuid) {
        super(options, parentLayer, uuid);

        this._targetUuid = options.targetUuid ? options.targetUuid : "";
        if ("targetUuid" in options) this._target = Q3.assets.objects[this._targetUuid] || Q3.assets.lights[this._targetUuid];
        this._targetPoint = options.targetPoint ? new THREE.Vector3().copy(options.targetPoint) : null;
    }

    render(width, height) {
        this.needsUpdate = this.needsUpdate || this._target;

        super.render(width, height);
    }

    _draw(width, height) {
        this.redraw(width, height);

        if (this._target) { fire("updateresizer"); }
    }

    _calcPosition(width, height) {
        /* POSITIONNING */
        let y, x, textWidth, textHeight;

        //then to determine top/left coords :
        //1. attach/detach of 3D target
        if (this._targetUuid && !this._target) {
            this._target = Q3.assets.objects[this._targetUuid] || Q3.assets.lights[this._targetUuid];

            if (this._target) {//new target
                Q3.layers.attachedObjects.push(this);
            }

        }

        const pr = RenderManager.pixelRatio;

        //positionning
        if (this._target) {
            this._vector.copy(this._targetPoint || new THREE.Vector3())
                .applyMatrix4(this._target.matrixWorld);

            const cam = RenderManager.activeCamera;
            const forward = cam.getWorldDirection(tmp);
            const diff = tmp2.setFromMatrixPosition(cam.matrixWorld).sub(this._vector);
            const dot = diff.dot(forward);

            if (dot < 0) {
                this._vector.project(cam);

                const vp = RenderManager.getViewPort();
                const vpWidth = vp.right - vp.left;
                const vpHeight = vp.bottom - vp.top;

                textWidth = this.width * width * pr;
                textHeight = this.height * height * pr;

                x = vp.left + vpWidth * (this._vector.x + 1) / 2 - textWidth / 2;
                y = vp.top + vpHeight * (1 - this._vector.y) / 2 - textHeight / 2;

                this.x = x / width / pr;
                this.y = y / height / pr;
            } else {
                this.x = this.y = -10000;
            }
        }

        x = this.x * width * pr;
        y = this.y * height * pr;

        return [x, y];
    }
}

export default Base2DElementDynamic;
export { Base2DElementDynamic };